import { render } from "./SplashScreen.vue?vue&type=template&id=fc87c64c&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import "../styles/SplashScreen.scss?vue&type=style&index=0&id=fc87c64c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc87c64c"]])

export default __exports__